import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleExclamation,
  faFilePen,
} from "@fortawesome/free-solid-svg-icons";
import { Spinner } from "react-bootstrap";
import * as React from "react";

export default function Loading({ message = null, error = false }) {
  if (message === null) {
    message = "Chargement en cours...";
  }

  let middleSection = (
    <Spinner
      animation="grow"
      variant={"info"}
      style={{ width: "200px", height: "200px", animationDuration: "2s" }}
    />
  );

  if (error) {
    middleSection = (
      <FontAwesomeIcon
        icon={faCircleExclamation}
        className="text-danger ms-2"
        size={"4x"}
      />
    );
  }
  return (
    <div className="container-fluid pl-0">
      <div
        className="d-flex flex-row justify-content-center align-items-center"
        style={{
          height: "100vh",
          background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
        }}
      >
        <div className="my-auto text-center">
          <div className="mb-4">
            <p
              className="text-xl text-white p-4 d-inline-block"
              style={{
                borderRadius: "50px",
                background:
                  "linear-gradient(135deg, var(--info-color) 0%, #0aa2c0 100%)",
                boxShadow: "var(--shadow-lg)",
              }}
            >
              Portail rapport PCRS
              <FontAwesomeIcon icon={faFilePen} size={"xl"} className="ms-2" />
            </p>
          </div>
          <div className="mt-4">{middleSection}</div>
          <div className="col-12 mt-4">
            <p className="text-lg fw-medium text-secondary">{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
